export class UEditorConfig {

  /**
   * 默认配置项
   *
   */
  options?: any;

  /**
   * ueditor.js的路径
   *
   */
  path?: string;

  /**
   * 二次开发的配置
   */
  hook?: Function;

  /**
   * 用于标记hook是否已经注册完成
   *
   */
  hook_finished?: boolean = false;
}
